import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Card, Row, Col, Paragraph, Container } from '../../../legacy/hui/src/styled/';
import styled from 'styled-components';
import { ButtonAction, ButtonReverse } from '../Bunnings/Buttons';

const modalStyle = {
  overlay: {
    position: 'fixed',
    zIndex: 9999,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    overflowY: 'auto',
    height: '100%'
  },
  content: {
    border: 'none',
    borderRadius: '8px',
    outline: 'none',
    padding: '0',
    top: '15%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, 0%)',
    maxWidth: '95%',
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch'
  }
};

export const TitleCard = Card.Section.extend`
  display: flex;
  align-items: center; 
  position: relative;
  justify-content: center; 
  font-size: 20px;
  color: #555659;
  font-weight: 400;
  min-height: 60px;
`;

const ModalCard = Card.extend`
  max-width: 600px;
`;

const MediaCard = Card.extend`
  padding: 5px 10px;
  overflow: hidden;
  margin-top: 0;
`;

const ParagraphSection = styled.div`
  padding: 0 20px;
`;

export const CloseButton = styled.div`
  right: 1rem;
  top: 1rem;
  position: absolute;
  cursor: pointer;
`;

const buttonFix = () => `
  display: block;
  max-width: 100%;
  margin: 0 auto;
`;

const ActWrap = styled.div`
  margin-bottom: 1rem;
`;

const ButtonAct = ButtonAction.extend`
  ${buttonFix()};
`;

const ButtonRev = ButtonReverse.extend`
  ${buttonFix()};
`;

export const Center = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;

const body = typeof document !== 'undefined' ? document.querySelector('body') : {};

export class InfoModal extends Component {
  static propTypes = {
    closeInfoModal: PropTypes.func,
    isOpen: PropTypes.bool,
    title: PropTypes.string,
    modalKey: PropTypes.string,
    children: PropTypes.node,
    switchVoucher: PropTypes.func
  };

  closeModal = () => {
    const { closeInfoModal, modalKey } = this.props;
    closeInfoModal(modalKey);
  };

  switchVou = () => {
    const { switchVoucher, modalKey } = this.props;
    this.closeModal();
    switchVoucher(modalKey);
  };

  render() {
    const { isOpen, switchVoucher } = this.props;
    const { closeModal, switchVou } = this;
    return (
      <Modal isOpen={isOpen} style={modalStyle} onRequestClose={closeModal} appElement={body}>
        <ModalCard center snow mt={0} mb={0} p={0}>
          <TitleCard secondary p={1} pr={2}>
            {this.props.title}
            <CloseButton aria-label="Close" onClick={closeModal}>
              <Paragraph m={0} secondary>
                ✕
              </Paragraph>
            </CloseButton>
          </TitleCard>
          <Card.Section style={{ boxShadow: 'none', padding: '2px 0' }}>
            <Container>
              <Row>
                <Col xs={12}>
                  <MediaCard snow>
                    <ParagraphSection>{this.props.children}</ParagraphSection>
                  </MediaCard>
                </Col>
                <Col xs={12} mb={2}>
                  <Center>
                    {switchVoucher && (
                      <ActWrap>
                        <ButtonAct
                          onClick={switchVou}
                        >{`I DON'T have an installation voucher`}</ButtonAct>
                      </ActWrap>
                    )}
                    <ButtonRev onClick={closeModal}>Cancel</ButtonRev>
                  </Center>
                </Col>
              </Row>
            </Container>
          </Card.Section>
        </ModalCard>
      </Modal>
    );
  }
}
